import {
    StyledHeading,
    StyledHeadingSpan,
    StyledHighlight,
    TextContainer,
    StyledLink,
} from './styles';
import { Box, Flex, BoxProps } from '@chakra-ui/react';

export interface ContactSectionProps extends BoxProps {
    version?: 'pl' | 'en';
}

const ContactSection: React.FC<ContactSectionProps> = ({ version = 'pl', ...rest }) => {
    return (
        <Box justifyContent={'center'} alignItems={'center'} {...rest}>
            <TextContainer>
                {version === 'pl' ? (
                    <StyledHeading>
                        Chcesz o coś zapytać?
                        <StyledHeadingSpan>Porozmawiaj z ekspertem IdoSell</StyledHeadingSpan>
                    </StyledHeading>
                ) : (
                    <StyledHeading>
                        Do you want to ask something?
                        <StyledHeadingSpan>Talk to an IdoSell expert</StyledHeadingSpan>
                    </StyledHeading>
                )}
                {version === 'pl' ? (
                    <StyledHighlight $style="normal">
                        Eksperci z działu sprzedaży są do twojej dyspozycji od poniedziałku do
                        piątku, w godzinach <span>9:00 - 17:00</span>
                    </StyledHighlight>
                ) : (
                    <StyledHighlight $style="normal">
                        Experts from the sales department are at your service Monday through Friday,
                        from <span>9:00 a.m. to 5:00 p.m.</span>
                    </StyledHighlight>
                )}
            </TextContainer>
            <Flex
                flexWrap={'wrap'}
                gap={{
                    base: 4,
                    lg: 6,
                }}
                justifyContent={'center'}
            >
                <StyledLink href="mailto:shop@idosell.com">shop@idosell.com</StyledLink>
                <StyledLink href="tel:+48914436600">+48 91 443 66 00</StyledLink>
            </Flex>
        </Box>
    );
};

export default ContactSection;
